import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { ConnectorsApi } from '../apis/connectors.api';
import { EnumOAuthInteractionMode } from '../enums/oauth-interaction-mode.enum';
import { IAuthorization } from '../interfaces/connection.interface';
import { IOauthResult } from '../interfaces/oauth-result.interface';
import { PopupSession } from './popup-session';

export { IOauthResult } from '../interfaces/oauth-result.interface';

const POPUP_WIDTH = 560;
const POPUP_HEIGHT = 720;

let popupSequence = 0;

const submitAuthorizationForm = (authorization: IAuthorization, target: string): void => {
  const form = document.createElement('form');
  form.method = authorization.authorizationMethod;
  form.action = authorization.authorizationUrl;
  form.target = target;
  form.style.display = 'none';

  const token = document.createElement('input');
  token.type = 'hidden';
  token.name = 'authorization_token';
  token.value = authorization.authorizationToken;

  form.appendChild(token);
  document.body.appendChild(form);
  form.submit();
  form.remove();
};

@Injectable({ providedIn: 'root' })
export class ConnectorOauthService {
  private readonly apiOrigin = new URL(environment.ceppemAiApi).origin;

  constructor(private connectorsApi: ConnectorsApi) {}

  openPopup(): Window | null {
    const name = `ceppem_connector_${Date.now()}_${++popupSequence}`;
    return window.open('about:blank', name, this.popupFeatures());
  }

  private popupFeatures(): string {
    const screen = window.screen as Screen & { availLeft?: number; availTop?: number };
    const left = (screen.availLeft ?? 0) + (screen.availWidth - POPUP_WIDTH) / 2;
    const top = (screen.availTop ?? 0) + (screen.availHeight - POPUP_HEIGHT) / 2;
    return (
      `popup=yes,width=${POPUP_WIDTH},height=${POPUP_HEIGHT},` +
      `left=${Math.round(left)},top=${Math.round(top)},resizable=yes,scrollbars=yes`
    );
  }

  start(slug: string, returnPath: string, popup: Window): Observable<IOauthResult> {
    return new Observable<IOauthResult>(subscriber => {
      const session = new PopupSession(this.connectorsApi, popup, this.apiOrigin);

      this.connectorsApi
        .createConnection(slug, {
          returnPath,
          interactionMode: EnumOAuthInteractionMode.Popup
        })
        .subscribe({
          next: authorization => {
            if (authorization.interactionMode !== EnumOAuthInteractionMode.Popup) {
              session.closePopup();
              submitAuthorizationForm(authorization, '_self');
              return;
            }
            session.begin(authorization, subscriber);
            submitAuthorizationForm(authorization, popup.name);
          },
          error: err => {
            session.dispose();
            subscriber.error(err);
          }
        });

      return () => session.dispose();
    });
  }
}
